<template>
  <div class="master">

    <div v-if="showDebug">
      Шаг: {{ step }};
      слудующий шаг: {{ canNext }};
      old: {{oldStep}};
      сразу: {{changeNextTo}}
      <div>
        {{marking}}
      </div>
    </div>

    <material-param-component
          v-show="step == 1"
          :materials="materials"
          :material-param="materialParam"
          :step-one="stepOne"
          :step="step"

          @changeMaterialParam="changeMaterialParam"
          @changeVoltage="changeVoltage"
          @nextStep="nextStep"
          @changeNext="changeNext"

    />

    <!-- диэлектрическая проницаемость-->
    <dielectric-constant
        v-show="step == 2"

        :translate="translate"
        :materials="materials"
        :material-param="materialParam"
        :step-two="stepTwo"
        :is-liquid="isLiquid()"
        :is-loose="isLoose()"
        :texts="texts"

        @backToStep="backToStep"
        @changeDielectric="changeDielectric"

      />

<!--    Длина чувствительного элемента-->
      <long-param-component
          v-show="step == 3"

          :long-param="longParam"
          :is-liquid="isLiquid()"
          :is-loose="isLoose()"
          :texts="texts"
          :lang="lang"
          :translate="translate"
          :step-two="stepTwo"
          :step="step"

          :default-letter-type="letterType"
          :default-number-type="numberType"

          @backToStep="backToStep"
          @changeLong="changeLongParam"
          @changeNumberType="changeNumberType"
          @changeLetterType="changeLetterType"
          @changeNextCount="changeNextCountTo"

        />

<!--    налипание -->
    <sticking-component
        v-show="step == 4"

        :translate="translate"
        :materials="materials"
        :material-param="materialParam"
        :sticking="sticking"
        :is-liquid="isLiquid()"
        :is-loose="isLoose()"
        :texts="texts"
        :lang="lang"
        :step="step"
        :dielectric-param="stepTwo"
        :long-param="longParam"


        @backToStep="backToStep"
        @changeSticking="changeSticking"
        @changeNumberType="changeNumberType"
        @changeLetterType="changeLetterType"
        @changeNextCount="changeNextCountTo"

      />

    <static-or-metal
        v-show="step == 5"

        :translate="translate"
        :materials="materials"
        :step-four="stepFour"
        :is-liquid="isLiquid()"
        :is-loose="isLoose()"
        :texts="texts"
        :material-param="materialParam"
        :lang="lang"
        :sticking="sticking"
        :dielectric-param="stepTwo"
        :long-param="longParam"
        :step="step"


        @changeNumberType="changeNumberType"
        @changeLetterType="changeLetterType"
        @backToStep="backToStep"
        @changeStepFour="changeStepFour"
        @changeNextCount="changeNextCountTo"
        @nextStep="nextStep"

      />

    <!-- Резьба узла крепления -->
    <thread-param-component
        v-show="step == 6"

        :translate="translate"
        :materials="materials"
        :material-param="materialParam"
        :letter-type="letterType"
        :thread-param="stepFive"
        :texts="texts"
        :lang="lang"
        :step="step"

        @changeThreadParam="changeThreadParam"
        @nextStep="nextStep"
        @backToStep="backToStep"
      />


    <temperature-component
        v-show="step == 7"

        :translate="translate"
        :materials="materials"
        :material-param="materialParam"
        :type-body="stepSix"
        :texts="texts"
        :lang="lang"
        :marking="marking"
        :step="step"

        @changeBodyParam="changeBodyParam"
        @backToStep="backToStep"
      />


    <bracing-param-component
        v-show="step == 8"

        :translate="translate"
        :materials="materials"
        :material-param="materialParam"
        :letter-type="letterType"
        :step-seven="stepSeven"
        :texts="texts"
        :lang="lang"
        :marking="marking"
        :step="step"

        @changeBracingParam="changeBracingParam"
        @backToStep="backToStep"
      />

    <cargo-component
        v-show="step == 9"

        :translate="translate"
        :materials="materials"
        :material-param="materialParam"
        :letter-type="letterType"
        :step-eight="stepEight"
        :texts="texts"
        :lang="lang"
        :marking="marking"
        :step="step"

        @changeCargoParam="changeCargoParam"
        @backToStep="backToStep"
        @changeNext="changeNext"
      />


    <marking
        :translate="translate"
        :type-param="typeParam"
        :step="step"
        :long-param="longParam"
        :voltage-param="stepOne"
        :thread-param="stepFive"
        :body-param="stepSix"
        :bracing-param="stepSeven"
        :cargo-param="stepEight"
        :can-next="canNext"
        :download="texts.download"

        :last-step="9"

        @nextStep="nextStep"
        ref="marking"
    ></marking>

  </div>
</template>

<script>

import Marking from './components/Marking.vue'
import {default as axios} from 'axios';
import config from './config';
import MaterialParamComponent from "./components/steps/materialParamComponent.vue";
import DielectricConstant from "./components/steps/dielectricConstant.vue";
import LongParamComponent from "./components/steps/longParamComponent.vue";
import StaticOrMetal from "./components/steps/staticOrMetal.vue";
import StickingComponent from "./components/steps/stickingComponent.vue";
import ThreadParamComponent from "./components/steps/threadParamComponent.vue";
import TemperatureComponent from "./components/steps/temperatureComponent.vue";
import BracingParamComponent from "./components/steps/bracingParamComponent.vue";
import CargoComponent from "./components/steps/CargoComponent.vue";

export default {
  name: 'App',
  components: {
    CargoComponent,
    BracingParamComponent,
    TemperatureComponent,
    ThreadParamComponent,
    StickingComponent,
    StaticOrMetal,
    LongParamComponent,
    DielectricConstant,
    MaterialParamComponent,
    Marking,
  },
  data() {
    return {
      materials: [],
      translate: [],
      texts: [],
      lang: '',

      step: 1,
      canNext: true,
      changeNextTo: 0,
      oldStep: 0,

      materialParam: 'liquid',
      stepOne: 17,
      stepTwo: '',
      longParam: '',
      stepFour: '',
      stepFive: '',
      stepSix: '',
      stepSeven: '',
      stepEight: '',
      sticking: '',


      numberType: '',
      letterType: '',

      showDebug: false

    }
  },
  mounted() {
      this.loadText()
      this.loadTranslate()
      this.loadMaterials()
      this.checkLang()
  },
  computed:{
    typeParam(){
        return this.numberType + this.letterType;
    },
    marking(){
      return {
        'materialParam': this.materialParam,
        'longParam': this.longParam,
        'voltageParam': this.stepOne,
        'dielectricParam': this.stepTwo,
        'staticOrMetal': this.stepFour,
        'threadParam': this.stepFive,
        'bodyParam': this.stepSix,
        'bracingParam': this.stepSeven,
        'cargoParam': this.stepEight,
        'sticking': this.sticking,
        'numberType': this.numberType,
        'letterType': this.letterType
      }
    }
  },
  methods: {

    changeMaterialParam(newVal){
        this.materialParam = newVal;
    },
    changeVoltage(val){
        this.stepOne = val;
    },
    changeDielectric(val){
        this.stepTwo = val;
    },
    changeLongParam(val){
        this.longParam = val;
    },
    changeNumberType(val){

      //костыль для ПВСУ
      if(this.stepOne == 30){
          if(val == 4) val = 2;
          if(val == 3) val = 1;
      }

      this.numberType = val;
    },
    changeLetterType(val){
      this.letterType = val;
    },
    changeStepFour(val){
        this.stepFour = val;
    },
    changeSticking(val){
        this.sticking = val;
    },
    changeThreadParam(val){
        this.stepFive = val;
    },
    changeBodyParam(val){
        this.stepSix = val;
    },
    changeBracingParam(val){
        this.stepSeven = val;
    },
    changeCargoParam(val){
        this.stepEight = val;
    },

    changeNext(val){
        this.canNext = val;
    },
    changeNextCountTo(val){
        this.changeNextTo = val;
    },


    nextStep(){

      this.oldStep = 0;

      let newStep = null;
      if(this.changeNextTo){
        newStep = this.changeNextTo;
        this.changeNextTo = null;
        this.oldStep = this.step;
      }else{
        newStep = this.step + 1;
      }

        //С грузом могут быть только гибкие чувствительные элементы “Г”, “Д”, “В”, пропускаем последний шаг
        if((this.letterType != 'Г' || this.letterType != 'Д' || this.letterType != 'В') && newStep == 9){
          this.stepEight = '0';
          this.step = 9;
          this.canNext = true;
          //this.$refs['marking'].showResult();
        }


        this.step = newStep;

        //значение длинны по умочанию
        if(this.step == 3 && !this.longParam) this.longParam = 2
    },
    backToStep(){

      let newStep = this.step - 1;

      if(this.oldStep > 0){
          newStep = this.oldStep;
          this.oldStep = 0;
      }

      this.step = newStep;

      if(this.step == 1){
        this.stepOne = '';
        this.numberType = '';
        this.letterType = '';
        this.stepTwo = '';
      }
      if(this.step == 2){
        this.longParam = '';
        this.stepTwo = '';
        this.changeNextTo = 0;
      }

      if(this.step == 4) this.sticking = '';
      if(this.step == 5) this.stepFour = '';
      if(this.step == 6) this.stepFive = '';
      if(this.step == 7) this.stepSix = '';
      if(this.step == 8){
        this.stepSeven = '';
        this.stepEight = '';
      }
      this.canNext = false;
      if(this.step == 3) this.canNext = true;
    },

    isLiquid(){
        return this.materialParam == 'liquid';
    },

    isLoose(){
        return this.materialParam == 'dry';
    },

    getVariants(variants, name){
      return (variants.filter(element => element.step == name));
    },

    loadTranslate() {
      axios
          .get(config.translateUrl,{
          })
          .then((response) => {
            if (response.data) {
              this.translate = response.data
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    loadMaterials() {
      axios
          .get(config.materialsUrl,{
          })
          .then((response) => {
            if (response.data) {
              this.materials = response.data
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    loadText(){
      axios
          .get(config.textUrl,{
          })
          .then((response) => {
            if (response.data) {
              this.texts = response.data[0]
            } else {
              console.log(response);
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    checkLang(){
      var domain = window.location.toString().replace('https://', '').replace('http://', '').split('.');

      if(domain.find(el => el == 'en')){
        this.lang = 'En'
      }
    }
  },
  watch:{

    step(state, prevState){

      if(prevState > state && this.step == 2){
        this.oldStep = 0;
        this.stepTwo = '';
      }


        if(this.step != 3 && state > prevState) this.canNext = false;
    },
    stepOne(){
      if(this.step == 1 && this.stepOne) this.canNext = true;
    },
    stepTwo(){
      if(this.step == 2 && this.stepTwo) this.canNext = true;
    },
    sticking(){
      if(this.step == 4 && this.sticking != null) this.canNext = true;
    },
    stepFour(){
      if(this.step == 5 && this.stepFour) this.canNext = true;
    },
    stepFive(){
      if(this.step == 6 && this.stepFive) this.canNext = true;
    },
    stepSix(){
      if(this.step == 7 && this.stepSix) this.canNext = true;
    },
    stepSeven(){
      if(this.step == 8 && this.stepSeven) this.canNext = true;
    },
    stepEight(){
      if(this.step == 9 && this.stepEight) this.canNext = true;
    },

    materialParam(){
      //reset all data
      this.stepOne = '';
      this.stepTwo = '';
      this.longParam = '';
      this.stepFour = '';
      this.stepFive = '';
      this.stepSix = '';
      this.stepSeven = '';
      this.stepEight = '';

      this.oldStep = 0;
      this.changeNextTo = 0;


      this.numberType = '';
      this.letterType = '';
      this.canNext = false;
    }

  }
}
</script>

<style>

.disable-param{
  background-color: #d4d4d4;
  border-radius: 2.5vw;
}
.quiz__aside{
  position: relative;
}
.loader-wrap{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  color: #009b7a;
  font-size: 20px;
  margin: 8% auto;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);

  background: #009b7a;
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}

.quiz {
  border-radius: 2.08333vw;
  background-color: #fff;
  margin-bottom: 1.38889vw;
  padding: 1.80556vw 2.01389vw; }
@media (min-width: 1800px) {
  .quiz {
    border-radius: 30px;
    margin-bottom: 20px;
    padding: 26px 29px; } }
@media (max-width: 1024px) {
  .quiz {
    border-radius: 9.375vmin;
    margin-bottom: 6.25vmin;
    padding: 3.75vmin 5.625vmin; } }
.quiz__tabs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  margin-bottom: 2.08333vw;
  border-bottom: 1px solid #F1F3FA; }
@media (min-width: 1800px) {
  .quiz__tabs {
    margin-bottom: 30px; } }
@media (max-width: 1024px) {
  .quiz__tabs {
    margin-bottom: 9.375vmin;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between; } }
.quiz__tab {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  padding-bottom: 1.25vw;
  font-size: 1.45833vw;
  font-weight: 500;
  color: #5A6C7D;
  position: relative;
  cursor: pointer;
  margin-right: 2.77778vw; }
.quiz__tab:after {
  content: "";
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  height: 5px;
  border-radius: 12px;
  background-color: #009B7A;
  visibility: hidden;
  opacity: 0; }
.quiz__tab.active {
  color: #009B7A; }
.quiz__tab.active:after {
  visibility: visible;
  opacity: 1; }
@media (min-width: 1800px) {
  .quiz__tab {
    padding-bottom: 18px;
    font-size: 21px;
    margin-right: 40px; } }
@media (max-width: 1024px) {
  .quiz__tab {
    padding: 5.625vmin 0;
    padding-top: 3.125vmin;
    font-size: 4.0625vmin;
    margin-right: 0; } }
.quiz__tab-content {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%; }
.quiz__tab-item-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; }
@media (max-width: 1024px) {
  .quiz__tab-item-wrap {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column; } }
.quiz__step {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
 }
.quiz__step.is-active {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; }
@media (max-width: 1024px) {
  .quiz__step {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column; } }
.quiz__aside {
  -ms-flex-preferred-size: 22.5vw;
  flex-basis: 22.5vw;
  padding-right: 1.38889vw; }
@media (min-width: 1800px) {
  .quiz__aside {
    -ms-flex-preferred-size: 324px;
    flex-basis: 324px;
    padding-right: 20px; } }
@media (max-width: 1024px) {
  .quiz__aside {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
    padding-right: 0;
    margin-bottom: 6.25vmin; } }
.quiz__content {
  -ms-flex-preferred-size: calc(100% -  22.5vw);
  flex-basis: calc(100% -  22.5vw);
  font-size: 1.04167vw;
  line-height: 1.66667vw; }
.quiz__content h3 {
  font-weight: 500;
  font-size: 1.18056vw;
  margin-top: 0; }
@media (min-width: 1800px) {
  .quiz__content h3 {
    font-size: 17px; } }
@media (max-width: 1024px) {
  .quiz__content h3 {
    font-size: 5.3125vmin; } }
.quiz__content ul li {
  padding-left: 1.38889vw;
  position: relative; }
.quiz__content ul li:before {
  content: "";
  position: absolute;
  left: 0.48611vw;
  top: 0.76389vw;
  width: 0.27778vw;
  height: 0.27778vw;
  border-radius: 50%;
  background-color: #5A6C7D; }
@media (min-width: 1800px) {
  .quiz__content ul li:before {
    top: 11px;
    left: 7px;
    width: 4px;
    height: 4px; } }
@media (max-width: 1024px) {
  .quiz__content ul li:before {
    top: 2.8125vmin;
    left: 2.5vmin;
    width: 1.25vmin;
    height: 1.25vmin; } }
@media (min-width: 1800px) {
  .quiz__content ul li {
    padding-left: 20px; } }
@media (max-width: 1024px) {
  .quiz__content ul li {
    padding-left: 6.25vmin; } }
@media (min-width: 1800px) {
  .quiz__content {
    -ms-flex-preferred-size: calc(100% -  324px);
    flex-basis: calc(100% -  324px);
    font-size: 15px;
    line-height: 24px; } }
@media (max-width: 1024px) {
  .quiz__content {
    -ms-flex-preferred-size: 100%;
    flex-basis: 100%;
    font-size: 4.0625vmin;
    line-height: 6.40625vmin; } }
.quiz__back {
  font-size: 1.04167vw;
  margin-bottom: 2.08333vw;
  padding: 0;
  background-color: transparent;
  border: none;
  color: #009B7A;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center; }
.quiz__back svg {
  width: 0.55556vw;
  height: 1.38889vw;
  margin-right: 1.11111vw; }
@media (min-width: 1800px) {
  .quiz__back svg {
    width: 8px;
    height: 20px;
    margin-right: 16px; } }
@media (max-width: 1024px) {
  .quiz__back svg {
    width: 2.5vmin;
    height: 6.25vmin;
    margin-right: 5vmin; } }
@media (min-width: 1800px) {
  .quiz__back {
    font-size: 15px;
    margin-bottom: 30px; } }
@media (max-width: 1024px) {
  .quiz__back {
    font-size: 4.6875vmin;
    margin-bottom: 9.375vmin; } }
.quiz__product {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; }
.quiz__product-image {
  position: relative;
  overflow: hidden;
  background: #FFFFFF;
  border-radius: 2.08333vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: 1px solid #F1F3FA;
  width: 13.19444vw;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin-right: 1.73611vw; }
@media (min-width: 1800px) {
  .quiz__product-image {
    border-radius: 30px;
    width: 190px;
    margin-right: 25px; } }
@media (max-width: 1024px) {
  .quiz__product-image {
    border-radius: 9.375vmin;
    width: 100%;
    max-width: 51.25vmin;
    margin-right: 0;
    margin-bottom: 6.25vmin; } }
.quiz__product-info {
  color: #5A6C7D; }
@media (max-width: 1024px) {
  .quiz__product {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column; } }
.quiz__footer {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center; }
@media (max-width: 1024px) {
  .quiz__footer {
    margin-top: 9.375vmin; } }
.quiz__btns .btn {
  height: 3.75vw;
  padding-left: 2.08333vw;
  padding-right: 2.08333vw;
  margin-left: 0.69444vw;
  margin-right: 0.69444vw; }
@media (min-width: 1800px) {
  .quiz__btns .btn {
    height: 54px;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: 10px;
    margin-right: 10px; } }
@media (max-width: 1024px) {
  .quiz__btns .btn {
    height: 16.875vmin;
    padding-left: 9.375vmin;
    padding-right: 9.375vmin;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 3.125vmin; } }
@media (max-width: 1024px) {
  .quiz__btns {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column; } }
.quiz__number-title {
  font-size: 1.04167vw;
  margin-bottom: 1.38889vw;
  font-weight: 500; }
@media (min-width: 1800px) {
  .quiz__number-title {
    font-size: 15px;
    margin-bottom: 20px; } }
@media (max-width: 1024px) {
  .quiz__number-title {
    font-size: 4.6875vmin;
    margin-bottom: 6.25vmin; } }
.quiz .number {
  -webkit-box-shadow: 0px 10px 40px rgba(0, 155, 122, 0.1);
  box-shadow: 0px 10px 40px rgba(0, 155, 122, 0.1); }
@media (max-width: 1024px) {
  .quiz .dne {
    display: none; } }

.dne {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  height: 5.27778vw;
  border-radius: 2.5vw;
  background-color: #F1F3FA;
  border: 1px solid #F1F3FA;
  font-size: 1.45833vw;
  font-weight: 500;
  margin: 1.45833vw 0 2.22222vw;
  -webkit-box-shadow: 0px 10px 40px rgba(0, 155, 122, 0.1);
  box-shadow: 0px 10px 40px rgba(0, 155, 122, 0.1); }
.dne__title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 5.27778vw;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-transform: uppercase;
  padding: 0 1.73611vw 0 2.08333vw;
  color: #5A6C7D; }
@media (min-width: 1800px) {
  .dne__title {
    height: 76px;
    padding: 0 25px 0 30px; } }
@media (max-width: 1024px) {
  .dne__title {
    height: 23.75vmin;
    padding: 0 7.8125vmin 0 9.375vmin; } }
.dne__types {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  /*height: 5.27778vw;*/
  border: 0.76389vw solid #fff;
  border-radius: 2.5vw; }
@media (min-width: 1800px) {
  .dne__types {
    /*height: 76px;*/
    border: 11px solid #fff;
    border-radius: 36px; } }
@media (max-width: 1024px) {
  .dne__types {
    height: 23.75vmin;
    border: 3.4375vmin solid #fff;
    border-radius: 11.25vmin; } }
.dne__type {
  /*min-width: 4.30556vw;*/
  height: 100%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  padding: 0 1.73611vw;
  -webkit-transition: all .3s ease-out;
  -o-transition: all .3s ease-out;
  transition: all .3s ease-out; }
.dne__type:first-child {
  border-radius: 2.5vw 0 0 2.5vw; }
@media (min-width: 1800px) {
  .dne__type:first-child {
    border-radius: 36px 0 0 36px; } }
@media (max-width: 1024px) {
  .dne__type:first-child {
    border-radius: 11.25vmin 0 0 11.25vmin; } }
.dne__type:last-child {
  border-radius: 0 2.5vw 2.5vw 0; }
@media (min-width: 1800px) {
  .dne__type:last-child {
    border-radius: 0 36px 36px 0; } }
@media (max-width: 1024px) {
  .dne__type:last-child {
    border-radius: 0 11.25vmin 11.25vmin 0; } }
@media (min-width: 1800px) {
  .dne__type {
    min-width: 62px;
    padding: 0 25px; } }
@media (max-width: 1024px) {
  .dne__type {
    min-width: 19.375vmin;
    padding: 0 7.8125vmin; } }
@media (min-width: 1800px) {
  .dne {
    height: 76px;
    border-radius: 36px;
    font-size: 21px;
    margin: 21px 0 32px; } }
@media (max-width: 1024px) {
  .dne {
    height: 23.75vmin;
    border-radius: 11.25vmin;
    font-size: 6.5625vmin;
    margin: 6.5625vmin 0 10vmin; } }

[aria-label][data-balloon-pos]:after {
  background-color: #343B4C;
  font-size: 0.97222vw;
  border-radius: 1.04167vw;
  padding: 1.04167vw;
  text-align: center; }
@media (min-width: 1800px) {
  [aria-label][data-balloon-pos]:after {
    font-size: 14px;
    border-radius: 15px;
    padding: 15px; } }

.quiz-checks .radio {
  margin-bottom: 0.69444vw;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; }
.quiz-checks .radio input:checked + .radio__text, .quiz-checks .radio.checked .radio__text {
  color: #fff;
  padding-left: 3.75vw; }
@media (min-width: 1800px) {
  .quiz-checks .radio input:checked + .radio__text, .quiz-checks .radio.checked .radio__text {
    padding-left: 54px; } }
@media (max-width: 1024px) {
  .quiz-checks .radio input:checked + .radio__text, .quiz-checks .radio.checked .radio__text {
    padding-left: 13.75vmin; } }
.quiz-checks .radio input:checked + .radio__text:before, .quiz-checks .radio.checked .radio__text:before {
  background-color: #009B7A; }
.quiz-checks .radio input:checked + .radio__text:after, .quiz-checks .radio.checked .radio__text:after {
  opacity: 1; }

.quiz-checks .radio__text {
  z-index: 1;
  font-size: 1.04167vw;
  font-weight: 500;
  color: #009B7A;
  padding: 0.90278vw 1.66667vw; }
.quiz-checks .radio__text:before {
  width: auto;
  height: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 2.5vw;
  z-index: -1;
  background-color: rgba(0, 155, 122, 0.02); }
@media (min-width: 1800px) {
  .quiz-checks .radio__text:before {
    border-radius: 36px; } }
@media (max-width: 1024px) {
  .quiz-checks .radio__text:before {
    border-radius: 11.25vmin; } }
.quiz-checks .radio__text:after {
  width: 1.38889vw;
  height: 1.38889vw;
  top: 50%;
  left: 1.66667vw;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);
  border: none;
  background: #fff url('assets/img/check-green2.svg') no-repeat center center;
}
@media (min-width: 1800px) {
  .quiz-checks .radio__text:after {
    width: 20px;
    height: 20px;
    left: 24px; } }
@media (max-width: 1024px) {
  .quiz-checks .radio__text:after {
    width: 5vmin;
    height: 5vmin;
    left: 6.25vmin;
    background-size: 3.125vmin; } }
@media (min-width: 1800px) {
  .quiz-checks .radio__text {
    font-size: 15px;
    padding: 13px 24px; } }
@media (max-width: 1024px) {
  .quiz-checks .radio__text {
    font-size: 3.90625vmin;
    padding: 4.0625vmin 7.5vmin; } }
@media (min-width: 1800px) {
  .quiz-checks .radio {
    margin-bottom: 10px; } }
@media (max-width: 1024px) {
  .quiz-checks .radio {
    margin-bottom: 1.875vmin; } }

@media (max-width: 1024px) {
  .quiz-checks {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column; } }


.radio {
  display: block;
  min-height: 1.38889vw; }
.radio input {
  position: absolute;
  z-index: -1;
  opacity: 0; }
.radio input:checked + .radio__text:after {
  opacity: 1; }
.radio__text {
  position: relative;
  padding: 0 0 0 2.43056vw;
  cursor: pointer;
  font-size: 1.04167vw; }
.radio__text:before {
  content: '';
  position: absolute;
  top: -0.20833vw;
  left: 0;
  width: 1.38889vw;
  height: 1.38889vw;
  border: 1px solid rgba(0, 155, 122, 0.04);
  border-radius: 50%;
  background: #FFF; }
@media (min-width: 1800px) {
  .radio__text:before {
    width: 20px;
    height: 20px;
    top: -3px; } }
@media (max-width: 1024px) {
  .radio__text:before {
    width: 5.625vmin;
    height: 5.625vmin;
    top: -0.9375vmin; } }
.radio__text:after {
  content: '';
  position: absolute;
  top: -0.20833vw;
  left: 0;
  width: 1.38889vw;
  height: 1.38889vw;
  border-radius: 50%;
  border: 3px solid #009B7A;
  opacity: 0;
  -webkit-transition: .2s;
  -o-transition: .2s;
  transition: .2s; }
@media (min-width: 1800px) {
  .radio__text:after {
    width: 20px;
    height: 20px;
    top: -3px; } }
@media (max-width: 1024px) {
  .radio__text:after {
    width: 5.625vmin;
    height: 5.625vmin;
    top: -0.9375vmin; } }
@media (min-width: 1800px) {
  .radio__text {
    font-size: 15px;
    padding: 0 0 0 35px; } }
@media (max-width: 1024px) {
  .radio__text {
    font-size: 4.6875vmin;
    padding: 0 0 0 10.9375vmin; } }
@media (min-width: 1800px) {
  .radio {
    min-height: 20px; } }
@media (max-width: 1024px) {
  .radio {
    min-height: 6.25vmin; } }



.dne__type--red { background-color: #EB5757; }
.dne__type--red:hover { background-color: #ff251b; }
.dne__type--orange { background-color: #F2994A; }
.dne__type--orange:hover { background-color: #cc6e00; }
.dne__type--yellow { background-color: #F2C94C; }
.dne__type--yellow:hover { background-color: #efbe29; }
.dne__type--green { background-color: #219653; }
.dne__type--green:hover { background-color: #1d8900; }
.dne__type--green-light { background-color: #27AE60; }
.dne__type--green-light:hover { background-color: #399d63; }
.dne__type--green-clear { background-color: #6FCF97; }
.dne__type--green-clear:hover { background-color: #54b17a; }
.dne__type--blue { background-color: #2F80ED; }
.dne__type--blue:hover { background-color: #0c62d5; }
.dne__type--blue-light { background-color: #2D9CDB; }
.dne__type--blue-light:hover { background-color: #1373ab; }
.dne__type--blue-clear { background-color: #56CCF2; }
.dne__type--blue-clear:hover { background-color: #1373ab; }
.dne__type--purple-clear { background-color: #BB6BD9; }
.dne__type--purple-clear:hover { background-color: #9c49bb; }
.dne__type--purple-light { background-color: #922DCF; }
.dne__type--purple-light:hover { background-color: #6e12a5; }
.dne__type--purple { background-color: #760F86; }
.dne__type--purple:hover { background-color: #4f085a; }
.dne__type--indigo-light {
  background-color: #005bff;
}
.dne__type--indigo-light:hover {
  background-color: #0049cc;
}
.dne__type--indigo {
  background-color: #003fb1;
}
.dne__type--indigo:hover {
  background-color: #002d7e;
}


.btn--green {
  background-color: #009b7a;
  color: #fff;
}

.btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0;
  border: 0;
  padding: 0;
  text-align: center;
  background-color: transparent;
  -webkit-transition: .4s;
  -o-transition: .4s;
  transition: .4s;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.btn {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 2.5vw;
  font-size: 1.04167vw;
  font-weight: 500;
  min-width: 11.45833vw;
  height: 2.84722vw;
  cursor: pointer;
}

.quiz__btns .btn {
  /*height: 3.75vw;*/
  padding-left: 2.08333vw;
  padding-right: 2.08333vw;
  margin-left: 0.69444vw;
  margin-right: 0.69444vw;
}
.btn--green-light {
  color: #009b7a;
  background-color: rgba(0,155,122,.04);
}
.btn--green-light:hover {
  background-color: #009b7a;
  color: #fff;
}
.btn--green {
  background-color: #009b7a;
  color: #fff;
}
.btn--green:hover {
  background-color: #008266;
}

.d-none{
  display: none;
}

.quiz .number {
  -webkit-box-shadow: 0 10px 40px rgb(0 155 122 / 10%);
  box-shadow: 0 10px 40px rgb(0 155 122 / 10%);
}

.number {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #f1f3fa;
  border-radius: 2.5vw;
}

.number__btn {
  width: 3.88889vw;
  height: 3.88889vw;
  -ms-flex-preferred-size: 3.88889vw;
  flex-basis: 3.88889vw;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  border-radius: 50%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: 2px solid #fff;
  background-color: rgba(0,155,122,.04);
}
.number__input {
  width: 4.58333vw;
  height: 3.88889vw;
  text-align: center;
  border: none;
  font-size: 1.18056vw;
  font-weight: 500;
  color: #5a6c7d;
}

.btn-minus{
  width: 14px;
  height: 48px;
  background: url('assets/img/minus.svg') no-repeat center center;
}

.btn-plus{
  width: 14px;
  height: 48px;
  background: url('assets/img/plus.svg') no-repeat center center;
}

.number__btn{
  cursor: pointer;
}

.number__input:focus-visible {
  outline: none;
}

.number__input::-webkit-outer-spin-button,
.number__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.quiz__product-info ul{
  list-style: none;
}
.dne-mobile > div{
  margin-bottom: 0.3rem;
}

a{
  color: #009B7A;
  text-decoration: none;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .number__btn {
    width: 14.375vmin;
    height: 13.75vmin;
    -ms-flex-preferred-size: 14.375vmin;
    flex-basis: 14.375vmin;
  }
  .number__btn svg {
    width: 4.375vmin;
  }
  .number__input {
    width: 15.625vmin;
    height: 13.75vmin;
    font-size: 5.3125vmin;
  }
  .number {
    border-radius: 11.25vmin;
  }
}

</style>
